var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":_vm.options.type,"value":_vm.options.visible,"tile":"","dense":true}},[_vm._v(" "+_vm._s(_vm.options.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }